var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sgl-news"},[_c('section',{staticClass:"content-section"},[_c('news-latest')],1),_c('section',{staticClass:"content-section"},[_c('news-all')],1),_c('scroll-top')],1)}
var staticRenderFns = []

export { render, staticRenderFns }